import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';
import styles from './Label.less';

const cxb = cx.bind(styles);

Label.propTypes = {
  /** Text for the label */
  text: PropTypes.string,
  side: PropTypes.oneOf(['top', 'left']),
};

/**
 * **Access:**
 * ```js
 * import { Label } from '@iss/client-react-components'
 * ```
 *
 */
export default function Label({ disabled, children, className, text, side = 'top', ...props }) {
  return (
    <label className={cxb('root', side, className)} {...props}>
      <Type.SubText1 as="div">{text}</Type.SubText1>
      {React.Children.map(children, (x) =>
        !x || typeof x === 'string' || 'disabled' in x.props ? x : React.cloneElement(x, { disabled })
      )}
    </label>
  );
}
